__turbopack_context__.v({
  "blogPost": "blog-module__R0QMoW__blogPost",
});
